export const CV_LINK = 'https://drive.google.com/file/d/1E6QhKSYliFUR5Ahx3JzI2-oN-CO29n3o/view';
